const ImageServices = {
    resizeMe(img) {
        const max_width = 180
        const max_height = 220

        let canvas = document.createElement('canvas');

        let width = img.width;
        let height = img.height;

        // calculate the width and height, constraining the proportions
        if (width > height) {
            if (width > max_width) {
                //height *= max_width / width;
                height = Math.round(height *= max_width / width);
                width = max_width;
            }
        } else {
            if (height > max_height) {
                //width *= max_height / height;
                width = Math.round(width *= max_height / height);
                height = max_height;
            }
        }

        // resize the canvas and draw the image data into it
        canvas.width = width;
        canvas.height = height;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        return canvas.toDataURL("image/jpeg", 0.7);
    },

    loadImage(url) {
        return new Promise((res, rej) => {
            let img = new Image();
            img.addEventListener('load', e => res(img));
            img.addEventListener('error', () => rej(new Error(`Failed to load image's URL: ${url}`)));
            img.src = url;
        });
    }
}

export {ImageServices}
